<div class="form-group container-fluid row">
  <h3>Contacts</h3>

  <div class="row">
    <div class="col-md-4">
      <h3>Names</h3>
      <div *ngFor="let contact of establishment.contactNames; let i = index" class="contact-item">
        <ch-contact [(ngModel)]="establishment.contactNames[i]" [name]="contactListName('contact-names',i)" (cancel)="removeContact(establishment.contactNames,i)"></ch-contact>
      </div>

      <small class="text-danger" *ngIf="shouldValidate && !validateContacts(establishment.contactNames)">
        At least one contact name is required.
      </small>

      <small class="text-danger" *ngIf="shouldValidate && checkSinglePrimary(establishment.contactNames)">
        Exactly one primary contact name is required.
      </small>

      <div class="contact-add-button">
        <button type="button" class="btn btn-success" aria-label="Close" (click)="addContact(establishment.contactNames)">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <div class="col-md-4">
      <h3>Emails</h3>
      <div *ngFor="let contact of establishment.contactEmails; let i = index" class="contact-item">
        <ch-contact [(ngModel)]="establishment.contactEmails[i]" [name]="contactListName('contact-emails',i)" (cancel)="removeContact(establishment.contactEmails,i)"></ch-contact>
      </div>

      <small class="text-danger" *ngIf="shouldValidate && checkSinglePrimary(establishment.contactEmails)">
        Exactly one primary contact email is required.
      </small>

      <div class="contact-add-button">
        <button type="button" class="btn btn-success" aria-label="Close" (click)="addContact(establishment.contactEmails)">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <div class="col-md-4">
      <h3>Phones</h3>
      <div *ngFor="let contact of establishment.contactPhones; let i = index" class="contact-item">
        <ch-contact [(ngModel)]="establishment.contactPhones[i]" [name]="contactListName('contact-phones',i)" (cancel)="removeContact(establishment.contactPhones,i)"></ch-contact>
      </div>

      <small class="text-danger" *ngIf="shouldValidate && checkSinglePrimary(establishment.contactPhones)">
        Exactly one primary contact phone is required.
      </small>

      <div class="contact-add-button">
        <button type="button" class="btn btn-success" aria-label="Close" (click)="addContact(establishment.contactPhones)">
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>

</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offers/contacts/contacts.component.html